<template>
  <div class="report-view-bar">
    <v-toolbar class="no-print report-toolbar" flat>
      <v-toolbar-title class="report-toolbar-title">
        {{ title }}
      </v-toolbar-title>

      <v-spacer />

      <download-excel
        v-if="hasExportData"
        :data="exportData"
        :fields="exportFields"
        :name="downloadFileName"
      >
        <v-btn rounded outlined small color="primary" class="mr-2">
          <span v-if="!$vuetify.breakpoint.xsOnly">Download</span>
          <v-icon small :right="!$vuetify.breakpoint.xsOnly">
            mdi-download
          </v-icon>
        </v-btn>
      </download-excel>

      <v-btn rounded color="primary" small dark @click="print">
        <span v-if="!$vuetify.breakpoint.xsOnly">Print</span>
        <v-icon small :right="!$vuetify.breakpoint.xsOnly">
          mdi-printer
        </v-icon>
      </v-btn>
    </v-toolbar>

    <v-container fluid class="report-header" v-if="currentBusiness">
      <v-row align="center">
        <v-col cols="12" md="7">
          <div class="business-name">
            {{ currentBusiness.name }}
          </div>

          <div class="business-line" v-if="currentBusiness.address">
            {{ currentBusiness.address }} {{ currentBusiness.city }},
            <span class="text-uppercase">{{ currentBusiness.state }}</span>
            {{ currentBusiness.zip }}
          </div>

          <div class="business-line" v-if="currentBusiness.phoneNumber">
            {{ currentBusiness.phoneNumber }}
          </div>

          <div
            class="business-line text-lowercase"
            v-if="currentBusiness.email"
          >
            {{ currentBusiness.email }}
          </div>

          <div
            class="business-line text-lowercase"
            v-if="currentBusiness.website"
          >
            {{ currentBusiness.website }}
          </div>
        </v-col>

        <v-col cols="12" md="5" class="text-md-right">
          <div class="report-name">
            {{ title }}
          </div>

          <div class="date-range" v-if="start">
            <v-chip small outlined color="primary">
              {{ start | moment("MM/DD/YYYY") }}
            </v-chip>

            <span class="date-separator">to</span>

            <v-chip small outlined color="primary">
              {{ end | moment("MM/DD/YYYY") }}
            </v-chip>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import JsonExcel from "vue-json-excel";

export default {
  name: "report-view-bar",

  components: {
    downloadExcel: JsonExcel,
  },
  props: {
    title: {
      type: String,
      default: "Report",
    },
    start: {
      type: String,
      default: null,
    },
    end: {
      type: String,
      default: null,
    },
    exportData: {
      type: Array,
      default: () => [],
    },
    exportFields: {
      type: Object,
      default: null,
    },
  },

  computed: {
    ...mapGetters("global", ["currentBusiness"]),

    hasExportData() {
      return Array.isArray(this.exportData) && this.exportData.length > 0;
    },

    downloadFileName() {
      return `${this.title || "report"}.xls`;
    },
  },

  created() {
    if (!this.currentBusiness) {
      this.initBusiness();
      this.initUser();
    }

    document.title = `Report - ${this.title}`;
  },

  methods: {
    ...mapActions("global", ["initUser", "initBusiness"]),

    print() {
      window.print();
    },
  },
};
</script>

<style scoped>
.report-view-bar {
  background: #fff;
}

.report-toolbar {
  padding: 6px 12px;
  border-bottom: 1px solid #e5e7eb;
  background: #f9fafb;
}

.report-toolbar-title {
  font-size: 16px;
  font-weight: 700;
  color: #1f2937;
  text-transform: capitalize;
}

.report-header {
  padding: 24px;
  border-bottom: 1px solid #e5e7eb;
}

.business-name {
  font-size: 24px;
  font-weight: 800;
  color: #111827;
  text-transform: capitalize;
}

.business-line {
  font-size: 13px;
  color: #4b5563;
  margin-top: 3px;
}

.report-name {
  font-size: 34px;
  font-weight: 900;
  color: var(--v-primary-base);
  text-transform: uppercase;
  line-height: 1.1;
}

.date-range {
  margin-top: 12px;
}

.date-separator {
  margin: 0 8px;
  color: #6b7280;
  font-size: 13px;
}

@media print {
  .no-print {
    display: none !important;
  }

  .report-header {
    padding: 0 0 16px 0;
    border-bottom: 1px solid #000;
  }

  .report-name {
    color: #000 !important;
  }
}
</style>